import React, { Fragment } from 'react';
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import { isDesktop } from "react-device-detect";

//styles
import './css/Custom.css';

//common
import Header from './components/common/Header';

//ads
import LateralIzquierdo from './ads/LateralIzquierdo';
import LateralDerecho from './ads/LateralDerecho';
import Zocalo from './ads/Zocalo';

//context
import GalleryProvider from './context/GalleryProvider';

//components
import Home from './components/home/Home';
import GalleryItems from './components/gallery/GalleryItems';

import { queryStringText } from './Constants';

const App = () => {

    return (
        <Fragment>
            <Header />
            <main className="container-fluid cont-principal px-0">
                <section className="d-flex justify-content-around">
                    {isDesktop && <LateralIzquierdo />}
                    <GalleryProvider >
                        <Router>
                            <HandleViews />
                        </Router>
                    </GalleryProvider>
                    {isDesktop && <LateralDerecho />}
                </section>        
                <section className="content-msgs">
                    <Zocalo isDesktop={isDesktop} />
                </section>        
            </main>            
        </Fragment>
    )
}

export default App;

const GetQuery = () => {
    return new URLSearchParams(useLocation().search);
}

const HandleViews = () => {

    const { search } = useLocation();    
    const query = GetQuery();
    const idPhoto = query.get(queryStringText);

    return (search.includes(idPhoto) && idPhoto !== '') ? <GalleryItems idPhoto={idPhoto} /> : <Home />;
}